export default [
    {id:"H",nombre:"Hembra"},
    {id:"M",nombre:"Macho"}
]